// extracted by mini-css-extract-plugin
export default {"headerImage":"TypeDiagnosisContents_headerImage__Zlw-Z","content":"TypeDiagnosisContents_content__QRxac"};